import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import UAParser from 'ua-parser-js';

@Injectable({
  providedIn: 'root',
})
export class UserAgent {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  isMobileDevice(): boolean {
    return this.getUserAgent().getDevice().type !== undefined;
  }

  getUserAgent() {
    if (isPlatformServer(this.platformId)) {
      throw new Error(
        'getUserAgent() cannot be used on the server as it will have unexpected effects due to the User-Agent not being part of the cache key in Varnish',
      );
    }
    return new UAParser(window.navigator.userAgent);
  }
}
